import React, { FC } from 'react'
import classnames from 'classnames'
import {
  Backdrop,
  Grow,
  Modal as MuiModal,
  ModalProps as MuiModalProps,
  makeStyles,
  IconButton,
  Theme
} from '@material-ui/core'
import { ReactComponent as Close } from 'assets/close.svg'

interface ModalProps extends MuiModalProps {
  closeFn?: (item?: any) => void
  classes?: {
    modal?: string
    paper?: string
    container?: string
    closeButton?: string
  }
  fullScreen?: boolean
  containerClass?: string
  paperRelative?: boolean
  hideClose?: boolean
}

export const Modal: FC<ModalProps> = ({
  open,
  classes: modalClasses,
  onClose,
  closeFn,
  containerClass,
  fullScreen,
  paperRelative,
  children,
  hideClose,
  ...props
}) => {
  const classes = useStyles()

  return (
    <MuiModal
      open={open}
      onClose={onClose}
      className={classnames(classes.modal, modalClasses?.modal)}
      closeAfterTransition={true}
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 1000 }}
      {...props}
    >
      <Grow in={open} timeout={800}>
        <div
          className={classnames(classes.paper, modalClasses?.paper)}
          style={paperRelative ? { position: 'relative' } : {}}
        >
          <div
            className={classnames(
              classes.container,
              modalClasses?.container,
              fullScreen && classes.fullScreen,
              containerClass
            )}
            style={paperRelative ? { position: 'initial' } : {}}
          >
            {!hideClose ? (
              <IconButton
                className={classnames(classes.closeButton, modalClasses?.closeButton, fullScreen && classes.blackIcon)}
                onClick={closeFn}
              >
                <Close width={20} height={20} />
              </IconButton>
            ) : null}
            {children}
          </div>
        </div>
      </Grow>
    </MuiModal>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'initial',
      justifyContent: 'initial'
    }
  },
  paper: {
    height: 'auto',
    display: 'flex',
    outline: '0',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    '& *': {
      outline: '0'
    }
  },
  container: {
    minWidth: 850,
    backgroundColor: theme.palette.primary.light,
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: '2rem',
    maxHeight: '100%',
    overflow: 'auto',
    overflowX: 'hidden',
    [theme.breakpoints.down('sm')]: {
      minWidth: 'initial',
      minHeight: 'initial',
      width: '100vw',
      height: '100%',
      overflow: 'auto',
      padding: 0
    }
  },
  closeButton: {
    position: 'absolute',
    top: '2px',
    right: '2px',
    zIndex: 1,
    '& svg': {
      color: theme.palette.VZBlack.main
    },
    [theme.breakpoints.down('sm')]: {
      top: 10,
      right: 10
    }
  },
  blackIcon: {
    '& svg': {
      zIndex: 1,
      color: theme.palette.VZBlack.main
    }
  },
  fullScreen: {
    height: '100vh',
    width: '100vw',
    backgroundColor: 'white',
    padding: 0
  }
}))
